import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/styles/makeStyles';
import * as React from 'react';

const useStyles = makeStyles({
  iconStyle: {
    fill: 'none',
    '&>path': {
      stroke: 'currentColor',
    },
  },
});

function SvgComponent(props: SvgIconProps) {
  const classes = useStyles();

  return (
    <SvgIcon className={classes.iconStyle} {...props}>
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zM7 11V7a5 5 0 019.9-1"
      ></path>
    </SvgIcon>
  );
}

const CoreUnlockIcon = React.memo(SvgComponent);
export default CoreUnlockIcon;
